import { ImportExcelService } from './../../services/importExcel/import-excel.service';
import { SettingsService } from './../../services/settings/settings.service';
import { Location } from '@angular/common';
import { PermissionService } from './../../services/permission.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {
  ConfirmationService,
  MessageService,
  PrimeNGConfig,
} from 'primeng/api';
import { SharedService } from 'src/app/services/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';

export interface UserData {
  name: string;
  role: string;
  userId: string;
  designation: string;
  entities: number;
  emailId: string;
  mobile: string;
}
export interface updateUserEntityData {
  idUserAccess?: number;
  EntityID?: number;
  EntityBodyID?: number;
  DepartmentID?: number;
  categoryID?: 0;
  userPriority?: number;
  maxAmount?: number;
  preApprove?: boolean;
  subRole:number;
}

export interface dropdownData {
  Entity: string;
  value: dropdownDatavalue[];
}
export interface dropdownDatavalue {
  name: string;
}

export interface selectedValue {
  idUserAccess?: number;
  entity?: string;
  entityBody?: string;
  entityDept?: string;
  EntityID?: number;
  EntityBodyID?: number;
  DepartmentID?: number;
  userPriority?: number;
  category?:string;
  categoryID?:number;
  maxAmount?: number;
  preApprove?: boolean;
  subRole?:any;
}
@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss'],
})
export class RolesComponent implements OnInit {
  normalRole: boolean = true;
  checked1: boolean = false;
  initialView: boolean = true;
  users: UserData[];
  usersData;
  roles = [];
  TotalRoles = ['Admin', 'Finance Controller', 'Customer'];
  NameOfRole: any;
  Flevel: any = null;
  FlevelData = ['level 1', 'level 2', 'level 3', 'level 4'];
  Froles = ['admin', 'customer', 'manager'];

  selectedEntityName;
  selectedEntityBodyName;
  selectedEntityDeptName;

  createUserCode: string;
  createUserName: string;
  emailIdInvite: string;
  InviteRole: string;
  InviteUserPassword: string;
  InviteFlevel: any;
  createUserDesignation;

  createRoleRequiredBoolean: boolean = false;
  newRoleName: string;
  newRoleDescription: string;

  events1: any[];

  loginUserData: any;
  visible = true;
  filteredEntities: any[];
  dEntityBody: dropdownData[] = [];
  dEntityDept: dropdownData[] = [];
  filterDentityBody: any[] = [];
  filterDentityDept: any[] = [];

  selectedEntitys: selectedValue[] = [];
  CreateNewRole: boolean = false;
  editUserdata: boolean = false;
  saveRoleBoolean: boolean;

  roletype: string;
  CustomerUserReadData = [];
  vendorAdminReadData;

  userName: string;
  firstName: string;
  lastName: string;
  designation;
  userEmail: string;
  userCode: any;
  custuserid: any;
  editRoleName: string;
  selectedEntityBody: any;
  selectedEntityDept: any;
  entityList: any;
  selectedEntityId: any;
  entityBodyList: any[];
  entityDeptList: any;
  SelectedCategory:any;
  SelectedEntity:any;

  showPaginator: boolean;
  DisplayRoleName: any[];

  roleInfoDetails: any;
  someParameterValue;

  AddorModifyUserBoolean: boolean = false;
  userRoleBoolean: boolean = false;
  invoiceBoolean: boolean = false;
  viewInvoiceBoolean: boolean = false;
  editInvoiceBoolean: boolean = false;
  changeApproveBoolean: boolean = false;
  financeApproveBoolean: boolean = false;
  spTriggerBoolean = false;
  vendorTriggerBoolean = false;
  configAccessBoolean: boolean = false;
  dashboardAccessBoolean: boolean = false;

  userAccess: number = 0;
  userRoleAccess = 0;
  invoiceAccess = 0;

  AccessPermissionTypeId: number;

  deleteBtnText: string;

  errorObject = {
    severity: 'error',
    summary: 'error',
    detail: 'Something went wrong',
  };
  addObject = {
    severity: 'success',
    summary: 'Success',
    detail: 'Created Successfully',
  };
  updateObject = {
    severity: 'info',
    summary: 'Updated',
    detail: 'Updated Successfully',
  };

  viewType = 'user';
  updateroleData;
  appied_permission_def_id: number;
  displayResponsive: boolean;
  displayAddUserDialog: boolean;
  headerEdituserboolean: boolean;
  updateUserEnt_body_id: number;
  updateUserEnt_dept_id: number;
  updateUsersEntityInfo: updateUserEntityData[] = [];
  updateEntityUserDummy: updateUserEntityData[] = [];
  userBoolean: boolean;
  userNotBoolean: boolean;
  resetBtnText: string;
  vendorList: any;
  vendorCreate: string;
  createVAccount: string;
  createVlastName: string;
  createVfirstName: string;
  idVendor: number;
  idVendorAccount: any;
  vendorSuperUsersReadData: any;
  showPaginatorSp: boolean;
  deleteBtnTextBoolean: boolean;
  deleteRoleBoolean: boolean;
  deactivateBoolean: boolean;
  resetVendorMail: any;
  vendorResetBtnBoolean: boolean;
  userResetBtnBoolean: boolean;
  max_role_amount = 0;
  role_priority: number;

  financeapproveDisplayBoolean: boolean;
  addRoleBoolean: boolean;
  row_customer = 10;
  first_cust = 0;
  approval_priority: any = null;
  skipList = [
    { text: 'Yes', value: true },
    { text: 'No', value: false },
  ];
  skip_approval_boolean: boolean;
  entityBaseApproveBoolean: boolean;
  subRole:any;

  alertBoolean:boolean;
  subroleList: any[];
  isAmountBasedON: boolean;
  isEvrythingGood: boolean;
  APIParam:any
  offsetCount = 1;
  serachStr = '';
  totalC_users: any;

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private sharedService: SharedService,
    private router: Router,
    public routeIn: ActivatedRoute,
    private permissionService: PermissionService,
    private SpinnerService: NgxSpinnerService,
    private _location: Location,
    private settingsService: SettingsService,
    private primengConfig: PrimeNGConfig,
    private ImportExcelService: ImportExcelService
  ) {
    routeIn.params.subscribe((params) => {
      this.setupComponent(params['someParam']);
    });
  }

  ngOnInit(): void {
    this.inIt();
  }

  inIt() {
    if (this.permissionService.addUsersBoolean == true) {
      this.router.navigate(['/customer/roles', 'createdUsers']);
      this.someParameterValue = 'createdUsers';
      this.primengConfig.ripple = true;
      this.DisplayCustomerUserDetails(1,50);
      this.toGetEntity();
      this.getDisplayTotalRoles();
      // this.getVendorsListTocreateNewVendorLogin();
      // this.getVendorSuperUserList();
      this.financeapproveDisplayBoolean =
        this.settingsService.finaceApproveBoolean;
      this.addRoleBoolean = this.permissionService.addUserRoleBoolean;
    } else {
      this.alertBoolean = true;
      this.displayResponsive = true;
      this.deleteBtnText = "Sorry!, you don't have access";
      this._location.back();
    }
  }
  setupComponent(someParam) {
    this.someParameterValue = someParam;
  }

  showDailog(e) {
    if (this.addRoleBoolean == true) {
      this.alertBoolean = false;
      this.deleteBtnText = 'Are you sure you want to delete this Role?';
      this.deleteRoleBoolean = true;
      this.vendorResetBtnBoolean = false;
      this.userResetBtnBoolean = false;
      this.deactivateBoolean = false;
      this.displayResponsive = true;
      this.sharedService.ap_id = e.idAccessPermissionDef;
    } else {
      alert('Sorry, you do not have access!');
    }
  }

  DeleteRole() {
    this.sharedService.deleteRole().subscribe((data: any) => {
      if (data.result == 'success') {
        this.messageService.add({
          severity: 'success',
          summary: 'Deleted',
          detail: 'Deleted Successfully',
        });
        this.getDisplayTotalRoles();
      } else {
        this.messageService.add(this.errorObject);
      }
    });
    this.displayResponsive = false;
  }
  onClickRow(i) {
    this.initialView = false;
    this.loginUserData = i;
    this.custuserid = i.idUser;
  }
  createRole() {
    if (this.addRoleBoolean == true) {
      this.router.navigate(['/customer/roles', 'createNewRole']);
      this.SpinnerService.hide();
      this.roletype = 'Create New Role';
      this.normalRole = false;
      this.newRoleName = '';
      this.CreateNewRole = true;
      this.editUserdata = false;
      this.saveRoleBoolean = true;
    } else {
      alert('Sorry, you do not have access!');
    }
  }
  cancelRoles() {
    this.router.navigate(['/customer/roles', 'definedRoles']);
    this.normalRole = true;
    this.CreateNewRole = false;
    this.editUserdata = false;
  }
  saveRoles() {
    if (!this.newRoleName) {
      this.createRoleRequiredBoolean = true;
    } else {
      this.addandUpdaterole();
      this.sharedService
        .createRole(JSON.stringify(this.updateroleData))
        .subscribe(
          (data: any) => {
            if (data.result) {
              this.messageService.add({
                severity: 'success',
                summary: 'Added',
                detail: 'Role Created Successfully',
              });
              this.getDisplayTotalRoles();
              this.normalRole = true;
              this.CreateNewRole = false;
              this.editUserdata = false;
              delete this.AccessPermissionTypeId;
            } else {
              this.messageService.add(this.errorObject);
              this.getDisplayTotalRoles();
            }
          },
          (error) => {
            if (error.statusText == 'Bad Request') {
              this.errorObject.detail =
                'Please provide other priorioty, the given priority is already taken.';
            } else {
              this.errorObject.detail = error.statusText;
            }
            this.messageService.add(this.errorObject);
          }
        );
      this.createRoleRequiredBoolean = false;
      this.normalRole = true;
      this.CreateNewRole = false;
      this.editUserdata = false;
    }
  }
  colseDiv() {
    this.initialView = true;
  }
  editRole(e) {
    if (this.addRoleBoolean == true) {
      this.router.navigate([
        '/customer/roles',
        `${e.idAccessPermissionDef}editRoleDetails`,
      ]);
      this.sharedService.ap_id = e.idAccessPermissionDef;
      this.newRoleName = e.NameOfRole;

      this.roletype = 'Edit Role';
      this.normalRole = false;
      this.CreateNewRole = true;
      this.saveRoleBoolean = false;
      this.editUserdata = false;
      this.SpinnerService.show();
      this.max_role_amount = 0;
      this.sharedService.displayRoleInfo().subscribe((data: any) => {
        this.roleInfoDetails = data.roleinfo;
        this.role_priority = this.roleInfoDetails.Priority;
        if (data.roleinfo.AmountApproveLevel) {
          this.max_role_amount = data.roleinfo.AmountApproveLevel.MaxAmount;
        }
        if (this.roleInfoDetails.User === 1) {
          this.AddorModifyUserBoolean = true;
        } else {
          this.AddorModifyUserBoolean = false;
        }
        if (this.roleInfoDetails.Permissions === 1) {
          this.userRoleBoolean = true;
        } else {
          this.userRoleBoolean = false;
        }
        if (this.roleInfoDetails.NewInvoice === 1) {
          this.invoiceBoolean = true;
        } else {
          this.invoiceBoolean = false;
        }
        this.vendorTriggerBoolean = this.roleInfoDetails.allowBatchTrigger;
        this.spTriggerBoolean = this.roleInfoDetails.allowServiceTrigger;
        this.configAccessBoolean = this.roleInfoDetails.isConfigPortal;
        this.dashboardAccessBoolean = this.roleInfoDetails.isDashboard;

        if (this.roleInfoDetails.AccessPermissionTypeId === 4) {
          this.viewInvoiceBoolean = true;
          this.editInvoiceBoolean = true;
          this.changeApproveBoolean = true;
          this.financeApproveBoolean = true;
        } else if (this.roleInfoDetails.AccessPermissionTypeId === 3) {
          this.viewInvoiceBoolean = true;
          this.editInvoiceBoolean = true;
          this.changeApproveBoolean = true;
          this.financeApproveBoolean = false;
        } else if (this.roleInfoDetails.AccessPermissionTypeId === 2) {
          this.viewInvoiceBoolean = true;
          this.editInvoiceBoolean = true;
          this.changeApproveBoolean = false;
          this.financeApproveBoolean = false;
        } else if (this.roleInfoDetails.AccessPermissionTypeId === 1) {
          this.viewInvoiceBoolean = true;
          this.editInvoiceBoolean = false;
          this.changeApproveBoolean = false;
          this.financeApproveBoolean = false;
        } else if (this.roleInfoDetails.AccessPermissionTypeId === 0) {
          this.viewInvoiceBoolean = false;
          this.editInvoiceBoolean = false;
          this.changeApproveBoolean = false;
          this.financeApproveBoolean = false;
        }
        this.SpinnerService.hide();
      });
    } else {
      alert('Sorry, you do not have access!');
    }
  }
  changeUserPermission(e) {
    if (e.target.checked === true) {
      this.userAccess = 1;
      this.AddorModifyUserBoolean = true;
    } else {
      this.userAccess = 0;
      this.AddorModifyUserBoolean = false;
    }
  }
  changeUserRolePermission(e) {
    if (e.target.checked === true) {
      this.userRoleAccess = 1;
      this.userRoleBoolean = true;
    } else {
      this.userRoleAccess = 0;
      this.userRoleBoolean = false;
    }
  }
  changeInvoicePermission(e) {
    if (e.target.checked === true) {
      this.invoiceAccess = 1;
      this.invoiceBoolean = true;
    } else {
      this.invoiceAccess = 0;
      this.invoiceBoolean = false;
    }
  }
  changeSpTriggerPermission(e) {
    if (e.target.checked === true) {
      this.spTriggerBoolean = true;
    } else {
      this.spTriggerBoolean = false;
    }
  }
  changeVendorTriggerPermission(e) {
    if (e.target.checked === true) {
      this.vendorTriggerBoolean = true;
    } else {
      this.vendorTriggerBoolean = false;
    }
  }
  changeViewInvoice(e) {
    if (e.target.checked === true) {
      this.viewInvoiceBoolean = true;
    } else {
      this.viewInvoiceBoolean = false;
      this.editInvoiceBoolean = false;
      this.changeApproveBoolean = false;
      this.financeApproveBoolean = false;
    }
  }
  changeEditInvoice(e) {
    if (e.target.checked === true) {
      this.viewInvoiceBoolean = true;
      this.editInvoiceBoolean = true;
    } else {
      this.viewInvoiceBoolean = true;
      this.editInvoiceBoolean = false;
      this.changeApproveBoolean = false;
      this.financeApproveBoolean = false;
    }
  }
  changeChangeApproveInvoice(e) {
    if (e.target.checked === true) {
      this.viewInvoiceBoolean = true;
      this.editInvoiceBoolean = true;
      this.changeApproveBoolean = true;
    } else {
      this.viewInvoiceBoolean = true;
      this.editInvoiceBoolean = true;
      this.changeApproveBoolean = false;
      this.financeApproveBoolean = false;
    }
  }
  changeFinanceApproveInvoice(e) {
    if (e.target.checked === true) {
      this.viewInvoiceBoolean = true;
      this.editInvoiceBoolean = true;
      this.changeApproveBoolean = true;
      this.financeApproveBoolean = true;
    } else {
      this.financeApproveBoolean = false;
    }
  }
  addandUpdaterole() {
    if (
      this.viewInvoiceBoolean == true &&
      this.editInvoiceBoolean == true &&
      this.changeApproveBoolean == true &&
      this.financeApproveBoolean == true
    ) {
      this.AccessPermissionTypeId = 4;
    } else if (
      this.viewInvoiceBoolean == true &&
      this.editInvoiceBoolean == true &&
      this.changeApproveBoolean == true &&
      this.financeApproveBoolean == false
    ) {
      this.AccessPermissionTypeId = 3;
    } else if (
      this.viewInvoiceBoolean == true &&
      this.editInvoiceBoolean == true &&
      this.changeApproveBoolean == false &&
      this.financeApproveBoolean == false
    ) {
      this.AccessPermissionTypeId = 2;
    } else if (
      this.viewInvoiceBoolean == true &&
      this.editInvoiceBoolean == false &&
      this.changeApproveBoolean == false &&
      this.financeApproveBoolean == false
    ) {
      this.AccessPermissionTypeId = 1;
    }

    this.updateroleData = {
      NameOfRole: this.newRoleName,
      Priority: this.role_priority,
      User: this.AddorModifyUserBoolean,
      Permissions: this.userRoleBoolean,
      AccessPermissionTypeId: this.AccessPermissionTypeId,
      allowBatchTrigger: this.vendorTriggerBoolean,
      isConfigPortal: this.configAccessBoolean,
      isDashboard: this.dashboardAccessBoolean,
      allowServiceTrigger: this.spTriggerBoolean,
      NewInvoice: this.invoiceBoolean,
    };
  }

  updateRoleInfoData() {
    this.addandUpdaterole();
    this.sharedService
      .updateRoleData(JSON.stringify(this.updateroleData))
      .subscribe(
        (data: any) => {
          if (data.result) {
            this.messageService.add(this.updateObject);
            this.getDisplayTotalRoles();
            this.normalRole = true;
            this.CreateNewRole = false;
            this.editUserdata = false;
            delete this.AccessPermissionTypeId;
          } else {
            this.messageService.add(this.errorObject);
          }
        },
        (error) => {
          this.errorObject.detail = error.statusText;
          this.messageService.add(this.errorObject);
        }
      );
  }

  toGetEntity() {
    this.entityList = [];
    this.sharedService.getEntityDept().subscribe((data: any) => {
      this.entityList = data;
    });
  }

  filterEntity(event) {
    let filtered: any[] = [];
    let query = event.query;
    for (let i = 0; i < this.entityList.length; i++) {
      let country = this.entityList[i];
      if (country.EntityName.toLowerCase().includes(query.toLowerCase())) {
        filtered.push(country);
      }
    }
    this.filteredEntities = filtered;
  }
  filterEntityBody(event) {
    if (this.entityBodyList) {
      let query = event.query;
      this.filterDentityBody = this.entityBodyList.filter((element) => {
        return (
          element.DepartmentName.toLowerCase().includes(query.toLowerCase())
        );
      });
    } else {
      this.alertBoolean = true;
      this.displayResponsive = true;
      this.deleteBtnText = 'Please select Entity';
    }
  }
  filterEntityDept(event) {
    if (this.entityDeptList) {
      let query = event.query;
      this.filterDentityDept = this.entityDeptList.filter((element) => {
        return (
          element.DepartmentName.toLowerCase().includes(query.toLowerCase())
        );
      });
    } else {
      this.alertBoolean = true;
      this.displayResponsive = true;
      this.deleteBtnText = 'Please select Department';
    }
  }
  onSelectEntity(value) {
    if (this.selectedEntitys?.length > 0 && this.AccessPermissionTypeId == 4 && this.entityBaseApproveBoolean) {
      if (
        this.selectedEntitys[this.selectedEntitys?.length - 1]?.entity &&
        this.selectedEntitys[this.selectedEntitys?.length - 1]?.subRole &&
        this.selectedEntitys[this.selectedEntitys?.length - 1]?.userPriority &&
        this.selectedEntitys[this.selectedEntitys?.length - 1]?.preApprove
      ) {
        this.sharedService.selectedEntityId = value.idEntity;
        this.selectedEntityId = value.idEntity;
        this.readDeparment();
        this.selectedEntitys.push({
          entity: value.EntityName,
          EntityID: value.idEntity,
        });
        this.updateUsersEntityInfo.push({
          idUserAccess: null,
          EntityID: value.idEntity,
          DepartmentID : null,
          categoryID :null,
          subRole : this.appied_permission_def_id
        });
        this.selectedEntityName = value.EntityName;
        this.isEvrythingGood =  true;
        this.checkStatus(0,'approval');
      } else {
        this.alertBoolean = true;
        this.displayResponsive = true;
        this.deleteBtnText = 'Please add all the mandatory fields';
        this.isEvrythingGood =  false;
      }
    } else {
      this.sharedService.selectedEntityId = value.idEntity;
      this.selectedEntityId = value.idEntity;
      this.readDeparment();
      this.selectedEntitys.push({
        entity: value.EntityName,
        EntityID: value.idEntity,
      });
      this.updateUsersEntityInfo.push({
        idUserAccess: null,
        EntityID: value.idEntity,
        DepartmentID : null,
        categoryID :null,
        subRole : this.appied_permission_def_id
      });
      this.selectedEntityName = value.EntityName;
      this.checkStatus(0,'approval');
    }
    this.subRole = '';
    this.getSkipList();
  }

  readDeparment(){
    this.entityBodyList = [];
    this.sharedService.getDepartment().subscribe((data: any) => {
      this.entityBodyList = data.department;
      
    });
  }


  readCategory(){
    this.sharedService.readCategory().subscribe((data:any)=>{
      
      // this.entityDeptList = this.entityBodyList[0].department
    })
  }

  /* To select Deparment  */
  onSelectEntityBody(e) {
    // let ent_body_name = this.entityBodyList.filter((element => {
    //   return element.DepartmentName == e.DepartmentName;
    // }))
    this.entityDeptList = []
    // this.updateUsersEntityInfo.push({EntityBodyID: e.idEntityBody});
    this.updateUsersEntityInfo.forEach((value) => {
      if (value.EntityID == this.selectedEntityId && !value.DepartmentID) {
        value.DepartmentID = e.idDepartment;
        value.categoryID = null;
        this.updateUserEnt_dept_id = e.idDepartment;
      }
    });
    this.selectedEntitys.forEach((element) => {
      if (
        element.entity == this.selectedEntityName &&
        (!element.entityDept || element.entityDept.length == 0)
      ) {
        element.entityDept = e.DepartmentName;
        element.DepartmentID = e.idDepartment;
        this.selectedEntityDeptName = '';
      }
    });
  }

  /* To selcet catagory */
  onSelectEntityDept(e) {
    this.updateUsersEntityInfo.forEach((value) => {
      if (
        value.EntityID == this.selectedEntityId &&
        value.EntityBodyID == this.updateUserEnt_body_id &&
        !value.categoryID
      ) {
        value.categoryID = e.categoryID;
        this.updateUserEnt_dept_id = e.categoryID;
      }
    });
    let count = 0;
    this.selectedEntitys.forEach((element) => {
      if (element.entityDept === e.DepartmentName) {
        this.alertBoolean = true;
        this.displayResponsive = true;
        this.deleteBtnText = 'Please select other Department';
      } else if (!element.entityDept || element.entityDept == '') {
        count = count + 1;
      } else {
        count = count + 1;
      }
    });
    if (count === this.selectedEntitys.length) {
      if (
        this.selectedEntitys[this.selectedEntitys.length - 1].entity ==
          this.selectedEntityName &&
        this.selectedEntitys[this.selectedEntitys.length - 1].entityBody ==
          this.selectedEntityBodyName &&
        (!this.selectedEntitys[this.selectedEntitys.length - 1].entityDept ||
          this.selectedEntitys[this.selectedEntitys.length - 1].entityDept
            .length == 0)
      ) {
        this.selectedEntitys[this.selectedEntitys.length - 1].entityDept =
          e.DepartmentName;
        this.selectedEntitys[this.selectedEntitys.length - 1].DepartmentID =
          e.idDepartment;
        this.selectedEntityDeptName = e.DepartmentName;
      }
    }
  }

  onSelectsubRole(e){
    let roleInfo = this.subroleList.filter(ele=>{
      return ele.idAccessPermissionDef == e;
    });
    this.updateUsersEntityInfo.forEach((value) => {
      if (value.EntityID == this.selectedEntityId && (value.subRole == this.appied_permission_def_id || !value.subRole)) {
        value.subRole = e;
      }
    });

    this.selectedEntitys.forEach((element) => {
      if (element.entity == this.selectedEntityName && !element.subRole) {
        element.subRole = roleInfo[0]['NameOfRole'];
      }
    });
    delete this.subRole;
  }
  
  onSelectPriority(e){
    this.checkStatus(e,'priority');
   
  }
  checkStatus(e,type) {
      this.updateUsersEntityInfo.forEach((value) => {
        if (value.EntityID == this.selectedEntityId) {
            value.userPriority = e;
        }
      });
      let bool = false;
      if(type == 'approval'){
        bool = true;
      }
    let obj = this.updateUsersEntityInfo[this.updateUsersEntityInfo.length-1]
    this.sharedService.checkPriority(bool,JSON.stringify(obj)).subscribe((data:any)=>{
      if(bool == true){
        if(data.status == 1){
          this.entityBaseApproveBoolean = true;
          this.isAmountBasedON = data.isAmountBased;
        } else {
          this.entityBaseApproveBoolean = false;
        }
      } else {
        if(data.status == 2){
            this.selectedEntitys.forEach((element) => {
              if (element.entity == this.selectedEntityName && !element.userPriority) {
                element.userPriority = e;
              }
            });
            delete this.approval_priority;
        } else if(data.status == 1){
          this.entityBaseApproveBoolean = true;
          this.alertBoolean = true;
          this.displayResponsive = true;
          this.deleteBtnText = data.result;
        }
      }

    })

  }

  onSelectAmount(e) {
    this.updateUsersEntityInfo.forEach((value) => {
      if (value.EntityID == this.selectedEntityId && !value.maxAmount) {
        value.maxAmount = e;
      }
    });
    this.selectedEntitys.forEach((element) => {
      if (element.entity == this.selectedEntityName && !element.maxAmount) {
        element.maxAmount = e;
      }
    });
    delete this.max_role_amount;
  }

  onSelectSkip(e) {
    this.updateUsersEntityInfo.forEach((value) => {
      if (value.EntityID == this.selectedEntityId && !value.preApprove) {
        value.preApprove = e;
      }
    });
    this.selectedEntitys.forEach((element) => {
      if (element.entity == this.selectedEntityName && !element.preApprove) {
        element.preApprove = e;
      }
    });
    this.getSkipList();
  }

  getSkipList(){
    return     this.skipList = [
      { text: 'Yes', value: true },
      { text: 'No', value: false },
    ];
  }

  // checkPriority(){
  //   let obj = this.updateUsersEntityInfo[this.updateUsersEntityInfo.length-1]
  //   this.sharedService.checkPriority(JSON.stringify(obj)).subscribe()
  // }
  onRemove(index, value) {
    if (this.selectedEntitys.length > 1) {
      if (value.idUserAccess) {
        this.updateUsersEntityInfo.push({
          idUserAccess: value.idUserAccess,
          EntityID: value.EntityID,
          EntityBodyID: value.EntityBodyID,
          DepartmentID: value.DepartmentID,
          subRole: this.appied_permission_def_id
        });
      } else {
        let Ent_id = value.EntityID ? value.EntityID : null;
        let Ent_body_id = value.EntityBodyID ? value.EntityBodyID : null;
        let Ent_dept_id = value.DepartmentID ? value.DepartmentID : null;
        this.updateUsersEntityInfo.forEach((element, index) => {
          if (Ent_id && Ent_body_id && Ent_dept_id) {
            if (
              element.EntityID == Ent_id &&
              element.EntityBodyID == Ent_body_id &&
              element.DepartmentID == Ent_dept_id
            ) {
              this.updateUsersEntityInfo.splice(index, 1);
            }
          } else if (Ent_id && Ent_body_id) {
            if (
              element.EntityID == Ent_id &&
              element.EntityBodyID == Ent_body_id
            ) {
              this.updateUsersEntityInfo.splice(index, 1);
            }
          } else {
            if (element.EntityID == Ent_id) {
              this.updateUsersEntityInfo.splice(index, 1);
            }
          }
        });
      }
      this.selectedEntitys.splice(index, 1);
    } else {
      this.errorObject.detail = 'Atleast one entity required';
      this.messageService.add(this.errorObject);
    }
  }

  editUser(value) {
    // this.getSkipList();
    delete this.skip_approval_boolean;
    this.router.navigate(['/customer/roles', `${value.idUser}editUser`]);
    if (value.isActive == 0) {
      this.resetBtnText = 'Resend Activation Link';
    } else {
      this.resetBtnText = 'Reset Account';
    }
    this.appied_permission_def_id = value.idAccessPermissionDef;
    this.sharedService.cuserID = value.idUser;
    this.headerEdituserboolean = true;
    this.normalRole = false;
    this.CreateNewRole = false;
    this.editUserdata = true;
    this.firstName = value.firstName;
    this.lastName = value.lastName;
    this.userEmail = value.email;
    this.userCode = value.UserCode;
    this.editRoleName = value.NameOfRole;
    this.AccessPermissionTypeId = value.AccessPermissionTypeId;
    if (value && value.MaxAmount) {
      this.Flevel = value.MaxAmount;
    }

    this.sharedService
      .readEntityUserData(value.idUser)
      .subscribe((data: any) => {
        data.result.forEach((element) => {
          // if (!element.EntityBody && !element.Department) {
          //   this.selectedEntitys.push({ entity: element.Entity.EntityName, entityBody: element.EntityBody, entityDept: element.DepartmentName, idUserAccess: element.UserAccess.idUserAccess, EntityID: element.Entity.idEntity, EntityBodyID: element.EntityBody, DepartmentID: element.idDepartment });
          //   this.updateEntityUserDummy.push({ idUserAccess: element.UserAccess.idUserAccess, EntityID: element.Entity.idEntity, EntityBodyID: element.EntityBody, DepartmentID: element.DepartmentName });
          // }
          // else if (!element.Department) {
          //   this.selectedEntitys.push({ entity: element.Entity.EntityName, entityBody: element.EntityBody.EntityBodyName, entityDept: element.DepartmentName, idUserAccess: element.UserAccess.idUserAccess, EntityID: element.Entity.idEntity, EntityBodyID: element.EntityBody.idEntityBody, DepartmentID: element.Department });
          //   this.updateEntityUserDummy.push({ idUserAccess: element.UserAccess.idUserAccess, EntityID: element.Entity.idEntity, EntityBodyID: element.EntityBody.idEntityBody, DepartmentID: element.DepartmentName });
          // }
          // else {
            let preApproveBool = false;
            if(element.UserAccess?.preApprove == 1){
              preApproveBool = true;
            } else {
              preApproveBool = false;
            }
            
            let roleName = this.subroleList?.filter(el=>{
              return el.idAccessPermissionDef == element.UserAccess?.subRole
            })
          this.selectedEntitys.push({
            entity: element.Entity?.EntityName,
            entityBody: element.EntityBody?.EntityBodyName,
            entityDept: element.Department?.DepartmentName,
            idUserAccess: element.UserAccess?.idUserAccess,
            EntityID: element.Entity?.idEntity,
            EntityBodyID: element.EntityBody?.idEntityBody,
            DepartmentID: element.Department?.idDepartment,
            maxAmount:element.UserAccess?.maxAmount,
            userPriority:element.UserAccess?.userPriority,
            preApprove:preApproveBool,
            subRole: roleName[0]?.NameOfRole
          });
          this.updateEntityUserDummy.push({
            idUserAccess: element.UserAccess?.idUserAccess,
            EntityID: element.Entity?.idEntity,
            EntityBodyID: element.EntityBody?.idEntityBody,
            DepartmentID: element.Department?.idDepartment,
            subRole:element.UserAccess?.idUserAccess
          });
          // }
        });
      });
  }

  canceleditUser() {
    this.router.navigate(['/customer/roles', 'createdUsers']);
    this.normalRole = true;
    this.CreateNewRole = false;
    this.editUserdata = false;
    this.selectedEntitys = [];
    this.updateUsersEntityInfo = [];
    this.userNotBoolean = false;
    this.userBoolean = false;
  }
  UpdateUser() {
    let editUser = {
      User: {
        firstName: this.firstName,
        lastName: this.lastName,
        UserName: this.userName,
        email: this.userEmail,
      },
      userentityaccess: this.updateUsersEntityInfo,
    };
    if (this.selectedEntitys?.length > 0 && this.AccessPermissionTypeId == 4 && this.entityBaseApproveBoolean) {
      if(this.updateUsersEntityInfo[this.updateUsersEntityInfo?.length - 1]?.EntityID &&
        this.updateUsersEntityInfo[this.updateUsersEntityInfo?.length - 1]?.subRole &&
        this.updateUsersEntityInfo[this.updateUsersEntityInfo?.length - 1]?.userPriority &&
        this.updateUsersEntityInfo[this.updateUsersEntityInfo?.length - 1]?.preApprove) 
        {
          this.updateAccessAPICall(editUser);
        } else {
          this.alertBoolean = true;
          this.displayResponsive = true;
          this.deleteBtnText = 'Please add all the mandatory fields';
        }
    } else {
      this.updateAccessAPICall(editUser);
    }
  }

  updateAccessAPICall(editUser){
    this.sharedService.updatecustomeruser(JSON.stringify(editUser)).subscribe(
      (data: any) => {
        if (data.result == 'Updated') {
          const userData = data.customer_user_details;
          let selectrole = {
            applied_uid: this.sharedService.cuserID,
            isUser: true,
            appied_permission_def_id: this.appied_permission_def_id,
          };

          if (this.AccessPermissionTypeId) {
            this.sharedService
              .editRole(JSON.stringify(selectrole))
              .subscribe((data: any) => {
                delete this.AccessPermissionTypeId;
                
              });
          }
          this.CustomerUserReadData = [];
          this.DisplayCustomerUserDetails(1,50);
          this.entityBaseApproveBoolean = false;
          this.messageService.add(this.updateObject);

          this.normalRole = true;
          this.CreateNewRole = false;
          this.editUserdata = false;
          this.selectedEntitys = [];
          this.firstName = '';
          this.lastName = '';
          this.updateUsersEntityInfo = [];

          // let amountApproval = {
          //   "applied_uid": this.sharedService.cuserID,
          //   "isUser": true,
          //   "MaxAmount": this.Flevel
          // };
          // this.sharedService.newAmountApproval(JSON.stringify(amountApproval)).subscribe((data: any) => { });
        } else {
          this.messageService.add(this.errorObject);
        }
      },
      (error) => {
        this.errorObject.detail = error.statusText;
        this.messageService.add(this.errorObject);
      }
    );
  }

  DisplayCustomerUserDetails(offset,limit) {
    this.roles = [];
    if(this.serachStr == ''){
      this.APIParam=`?offset=${offset}&limit=${limit}`;
    } else {
     this.APIParam=`?offset=${offset}&limit=${limit}&uni_api_filter=${this.serachStr}`;
    }
    this.SpinnerService.show();
    this.sharedService.readcustomeruser(this.APIParam).subscribe((data: any) => {
      let usersList = [];
      this.totalC_users = data?.total_users;
      data?.user_list?.forEach((element) => {
        let mergedData = {
          ...element.AccessPermission,
          ...element.AccessPermissionDef,
          ...element.User
        };
        mergedData.LogName = element?.LogName;
        usersList.push(mergedData);
      });
      this.CustomerUserReadData = this.CustomerUserReadData.concat(usersList);
      // this.ImportExcelService.exportExcel(this.CustomerUserReadData);
      if (this.CustomerUserReadData.length > 10) {
        this.showPaginator = true;
      }
      this.SpinnerService.hide();
    }, err=>{
      this.SpinnerService.hide();
    });
  }

  createCustomerUserPage() {
    this.headerEdituserboolean = false;
    this.normalRole = false;
    this.CreateNewRole = false;
    this.editUserdata = true;
    this.userName = '';
    this.userEmail = '';
    this.editRoleName = '';
    this.Flevel = '';
    this.selectedEntitys = [];
    delete this.skip_approval_boolean;
    this.getSkipList();
  }

  userCheck(name) {
    this.sharedService.userCheck(name).subscribe((data: any) => {
      if (!data.LogName) {
        this.userBoolean = true;
        this.userNotBoolean = false;
      } else {
        this.userNotBoolean = true;
        this.userBoolean = false;
      }
    });
  }

  toCreateUser() {
    let requiredError = {
      severity: 'error',
      summary: 'Fill required fields',
      detail: 'Please fill all the given fields',
    };
    if (
      this.updateUsersEntityInfo.length > 0 &&
      this.userName != '' &&
      this.userNotBoolean == false
    ) {
      
      let createUserData = {
        n_cust: {
          email: this.userEmail,
          firstName: this.firstName,
          lastName: this.lastName,
          userentityaccess: this.updateUsersEntityInfo,
          role_id: this.appied_permission_def_id,
        },
        n_cred: {
          LogName: this.userName,
          LogSecret: 'string',
        },
      };
      if (this.selectedEntitys?.length > 0 && this.AccessPermissionTypeId == 4 && this.entityBaseApproveBoolean) {
        if(this.updateUsersEntityInfo[this.updateUsersEntityInfo?.length - 1]?.EntityID &&
          this.updateUsersEntityInfo[this.updateUsersEntityInfo?.length - 1]?.subRole &&
          this.updateUsersEntityInfo[this.updateUsersEntityInfo?.length - 1]?.userPriority &&
          this.updateUsersEntityInfo[this.updateUsersEntityInfo?.length - 1]?.preApprove) 
          {
            this.addUserAPICall(createUserData,requiredError);
          } else {
            this.alertBoolean = true;
            this.displayResponsive = true;
            this.deleteBtnText = 'Please add all the mandatory fields';
          }
      } else {
            this.addUserAPICall(createUserData,requiredError);
      }

      
    } else {
      this.messageService.add(requiredError);
    }
  }

  addUserAPICall(createUserData,requiredError){
    this.sharedService
    .createNewUser(JSON.stringify(createUserData))
    .subscribe(
      (data) => {
        this.messageService.add(this.addObject);
        this.normalRole = true;
        this.CreateNewRole = false;
        this.editUserdata = false;
        this.selectedEntitys = [];
        this.updateUsersEntityInfo = [];
        this.userNotBoolean = false;
        this.userBoolean = false;
        this.firstName = '';
        this.lastName = '';
        this.CustomerUserReadData = [];
        this.DisplayCustomerUserDetails(1,50);
        this.entityBaseApproveBoolean = false;
      },
      (error) => {
        if (error.status == 422) {
          this.messageService.add(requiredError);
        } else {
          this.errorObject.detail = error.statusText;
          this.messageService.add(this.errorObject);
        }
      }
    );
  }

  selectRole(e) {
    let item = this.DisplayRoleName.filter((item) => {
      return e.indexOf(item.NameOfRole) > -1;
    });
    this.appied_permission_def_id = item[0].idAccessPermissionDef;
    this.AccessPermissionTypeId = item[0].AccessPermissionTypeId;
  }

  selectedRole(e) {}
  selectedFlevel(e) {}

  changeUserRole(e, value) {
    let item = this.DisplayRoleName.filter((item) => {
      return value.indexOf(item.NameOfRole) > -1;
    });
    let roleData = {
      applied_uid: e.idUser,
      isUser: true,
      appied_permission_def_id: item[0].idAccessPermissionDef,
    };
    this.sharedService
      .editRole(JSON.stringify(roleData))
      .subscribe((data: any) => {
        if (data.result == 'success') {
          this.messageService.add({
            severity: 'success',
            summary: 'Role changed',
            detail: 'Role Changed Successfully',
          });
        } else {
          this.messageService.add(this.errorObject);
        }
      });
  }
  getDisplayTotalRoles() {
    this.sharedService.displayRolesData().subscribe((data: any) => {
      // this.SpinnerService.hide();
      this.DisplayRoleName = data.roles;
      this.subroleList = this.DisplayRoleName.filter(ele=>{
        return ele.AccessPermissionTypeId == 4;
      })
      this.DisplayRoleName = this.DisplayRoleName.sort(
        (a, b) => b.isDefault - a.isDefault
      );
    });
  }

  getVendorsListTocreateNewVendorLogin() {
    this.sharedService
      .getVendorsListToCreateNewlogin('')
      .subscribe((data: any) => {
        this.vendorList = data.vendorlist;
      });
  }

  selectVendor(value) {
    const accontData = this.vendorList.filter((element) => {
      return value === element.VendorName;
    });
    this.idVendor = accontData[0].idVendor;
  }

  createVendorSuprUser() {
    let vendorSpUserData = {
      n_ven_user: {
        firstName: this.createVfirstName,
        lastName: this.createVlastName,
        email: this.emailIdInvite,
        role_id: 7,
        uservendoraccess: [
          {
            vendorUserID: 0,
            vendorID: this.idVendor,
            vendorAccountID: null,
          },
        ],
      },
      n_cred: {
        LogName: this.createUserName,
        LogSecret: 'string',
        userID: 0,
      },
    };
    this.sharedService
      .createVendorSuperUser(JSON.stringify(vendorSpUserData))
      .subscribe(
        (data: any) => {
          this.messageService.add(this.addObject);
          this.displayAddUserDialog = false;
          this.createVfirstName = '';
          this.createVlastName = '';
          this.emailIdInvite = '';
          // this.getVendorSuperUserList();
        },
        (error) => {
          this.errorObject.detail = error.statusText;
          this.messageService.add(this.errorObject);
        }
      );
  }

  getVendorSuperUserList() {
    this.sharedService.readVendorSuperUsersList().subscribe((data: any) => {
      let vendorUsersList = [];
      data.forEach((element) => {
        let mergerdObject = {
          ...element.AccessPermission,
          ...element.AccessPermissionDef,
          ...element.User,
          ...element.Vendor,
        };
        // mergerdObject.idVendorUserAccess = element.idVendorUserAccess;
        vendorUsersList.push(mergerdObject);
      });
      this.vendorAdminReadData = vendorUsersList;
      if (this.vendorAdminReadData.length > 10) {
        this.showPaginatorSp = true;
      }
    });
  }
  resetPassword() {
    this.alertBoolean = false;
    this.deleteBtnText = 'Are you sure you want to Reset this Account?';
    this.vendorResetBtnBoolean = false;
    this.userResetBtnBoolean = true;
    this.deactivateBoolean = false;
    this.deleteRoleBoolean = false;
    this.displayResponsive = true;
  }
  resetPasswordUserAPI() {
    this.sharedService.resetPassword(this.userEmail).subscribe(
      (data: any) => {
        this.displayResponsive = false;
        this.addObject.detail = data.result;
        this.errorObject.detail = data.result;
        if (data.result != 'failed mail') {
          this.messageService.add(this.addObject);
          this.displayResponsive = false;
          this.CustomerUserReadData = [];
          this.DisplayCustomerUserDetails(1,50);
        } else {
          this.messageService.add(this.errorObject);
        }
      },
      (error) => {
        this.errorObject.detail = error.statusText;
        this.messageService.add(this.errorObject);
      }
    );
  }
  resetPasswordVendor(mail) {
    this.alertBoolean = false;
    this.deleteBtnText = 'Are you sure you want to Reset this Account?';
    this.displayResponsive = true;
    this.vendorResetBtnBoolean = true;
    this.userResetBtnBoolean = false;
    this.deactivateBoolean = false;
    this.deleteRoleBoolean = false;
    this.resetVendorMail = mail;
  }

  resetPassVendorAPI() {
    this.sharedService.resetPassword(this.resetVendorMail).subscribe(
      (data: any) => {
        this.addObject.detail = data.result;
        this.errorObject.detail = data.result;
        if (data.result != 'failed mail') {
          this.messageService.add(this.addObject);
          this.displayResponsive = false;
          // this.getVendorSuperUserList();
        } else {
          this.messageService.add(this.errorObject);
        }
      },
      (error) => {
        this.errorObject.detail = error.statusText;
        this.messageService.add(this.errorObject);
      }
    );
  }

  confirmationPopUp(id, text) {
    this.alertBoolean = false;
    this.deleteBtnText = `Are you sure you want to ${text} this Account?`;
    this.deactivateBoolean = true;
    this.deleteRoleBoolean = false;
    this.vendorResetBtnBoolean = false;
    this.userResetBtnBoolean = false;
    this.displayResponsive = true;
    this.custuserid = id;
  }

  activa_deactive() {
    this.sharedService.activate_deactivate(this.custuserid).subscribe(
      (data: any) => {
        this.addObject.detail = data.result;
        this.messageService.add(this.addObject);
        this.displayResponsive = false;
        this.custuserid = null;
        this.CustomerUserReadData = [];
        this.DisplayCustomerUserDetails(1,50);
        // this.getVendorSuperUserList();
      },
      (error) => {
        this.errorObject.detail = error.statusText;
        this.messageService.add(this.errorObject);
      }
    );
  }

  paginate(event, type) {

    if(this.first_cust < event.first){
      this.offsetCount++;
      this.DisplayCustomerUserDetails(this.offsetCount,50);
    }
    this.row_customer = event.rows;
    this.first_cust = event.first;
  }
  filterString(val){
    this.CustomerUserReadData = [];
    this.serachStr = val;
    this.DisplayCustomerUserDetails(1,50);
  }
}
